// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"a6b77db6","482":"0e5b5912","529":"b987fd13","724":"30fb98ad"}[chunkId] + ".chunk.js";
};